// ── MetricsTile ✦ — single calm count tile for the admin panel ──
//
// Reusable across the Moderation overview AND the Parent Dashboard
// adoption strip. The visual contract is deliberately boring —
// matches Phase D's "operational confidence, not behavioural
// analytics" framing.
import React from 'react';
import { TEXT, FONT_STACK } from './palette';

export const MetricsTile = ({ label, value, icon: Icon, accent, testid, onClick }) => (
  <button
    onClick={onClick}
    data-testid={testid}
    style={{
      cursor: 'pointer', textAlign: 'left',
      padding: 16, borderRadius: 18,
      background: `linear-gradient(135deg, ${accent}1A, rgba(255,255,255,0.02))`,
      border: `1px solid ${accent}33`, color: TEXT, fontFamily: FONT_STACK,
      boxShadow: `0 6px 18px ${accent}1A`,
      transition: 'transform .15s ease, box-shadow .15s ease',
    }}
    onMouseDown={(e) => { e.currentTarget.style.transform = 'translateY(1px)'; }}
    onMouseUp={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
  >
    <div style={{
      display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6,
    }}>
      <Icon size={16} weight="fill" color={accent} />
      <p style={{
        margin: 0, fontWeight: 800, fontSize: 11, letterSpacing: '0.18em',
        textTransform: 'uppercase', color: accent,
      }}>{label}</p>
    </div>
    <p style={{
      margin: 0, fontWeight: 900, fontSize: 28, color: TEXT, letterSpacing: '-0.02em',
    }}>{value}</p>
  </button>
);
